import cx from 'clsx';
import React from 'react';

import { ReactComponent as AiCharacterDarkIcon } from '@assets/svg/ai-assistant/ai-character-dark.svg';
import { ReactComponent as AiCharacterLightIcon } from '@assets/svg/ai-assistant/ai-character-light.svg';

import { selectAppPersistDarkMode } from '@store/useAppStorePersist';

import style from './style.module.scss';

interface IProps {
  isLoading?: boolean;
  hasError?: boolean;
}

const ChatCharacter: React.FC<IProps> = ({ isLoading = false, hasError = false }) => {
  const darkMode = selectAppPersistDarkMode();

  return (
    <div className={style.characterIconWrapper}>
      {darkMode ? (
        <AiCharacterDarkIcon
          className={cx(style.characterIcon, {
            [style.isLoadingIcon]: isLoading,
            [style.isErrorIcon]: hasError,
          })}
        />
      ) : (
        <AiCharacterLightIcon
          className={cx(style.characterIcon, {
            [style.isLoadingIcon]: isLoading,
            [style.isErrorIcon]: hasError,
          })}
        />
      )}
    </div>
  );
};

export default ChatCharacter;
